import { TColumnsBannerContainer } from '../ColumnsBanner.types';
import { ColumnsContainerVariant } from './ColumnBannerContainer.style';

export const ColumnsBannerContainer = ({ children, variant }: TColumnsBannerContainer) => (
  <ColumnsContainerVariant variant={variant}>{children}</ColumnsContainerVariant>
);
